<template>
  <v-row no-gutters>
    <v-col v-for="button in filteredButtons" :key="button.name" cols="auto">
      <v-badge
        overlap
        bordered
        :content="getButtonAmount(button.amount)"
        :offset-y="15"
        :offset-x="15"
        :value="button.amount > 0"
        color="error"
      >
        <base-rounded-button
          @click="onClick(button.name, button)"
          color="rgba(235, 235, 235, 0.5)"
          size="x-small"
          v-bind="button"
          icon-color="#202124"
        >
        </base-rounded-button>
      </v-badge>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import BaseRoundedButton from '@/components/BaseRoundedButton';

export default {
  name: 'FeatureCardShowButtons',
  components: {
    BaseRoundedButton,
  },
  props: {
    permissions: {
      type: Number,
      required: true,
    },
    featureProps: {
      type: Object,
      default: null,
    },
    iconsToShow: {
      type: Array,
      default: () => ['showHistory', 'showNotes', 'showAttachments', 'showRelations'],
    },
  },
  computed: {
    relations: get('relations/relations'),
    dataSourceName: get('layers/currentLayer@data_source_name'),
    featureId() {
      return this.$route?.params?.fid;
    },
    relationsCount() {
      return this.relations?.[this.dataSourceName]?.[this.featureId]?.length || [];
    },
    baseButtons() {
      return [
        {
          name: 'showHistory',
          icon: 'mdi-lightning-bolt',
          tooltip: this.$i18n.t('button.showHistory'),
          amount: this.featureProps[Object.keys(this.featureProps).find(key => key.includes('history_count'))],
        },
        {
          name: 'showNotes',
          icon: 'mdi-comment-text',
          tooltip: this.$i18n.t('button.showNotes'),
          isVisible: this.permissions > 0,
          amount: this.featureProps[Object.keys(this.featureProps).find(key => key.includes('notes_count'))],
        },
        {
          name: 'showAttachments',
          icon: 'mdi-paperclip',
          tooltip: this.$i18n.t('button.showAttachments'),
          isVisible: this.permissions > 0,
          amount: this.featureProps[Object.keys(this.featureProps).find(key => key.includes('attachments_count'))],
        },
        {
          name: 'showRelations',
          icon: 'mdi-transit-connection-horizontal',
          tooltip: this.$i18n.t('button.showRelations'),
          amount: this.relationsCount,
        },
      ];
    },
    filteredButtons() {
      return this.baseButtons.filter(
        button => (button.isVisible === undefined || button.isVisible) && this.iconsToShow.includes(button.name)
      );
    },
  },
  methods: {
    onClick(name, button) {
      this.$emit(name, button);
    },
    getButtonAmount(amount) {
      return amount ? amount.toString() : null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-badge__badge {
  z-index: 2 !important;
}
</style>
